"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hrOfferQuerySchema = exports.hrOfferDeclineSchema = exports.hrOfferExtendSchema = exports.hrOfferStatusEnum = void 0;
const zod_1 = require("zod");
/**
 * HR PHASE 2D — offer (recruitment roadmap, closes out Phase 2). No
 * compensation entity exists yet (Phase 7) — `compensationSummary` is free
 * text, same disclosed posture used elsewhere for "no master yet" fields.
 */
exports.hrOfferStatusEnum = zod_1.z.enum(['EXTENDED', 'ACCEPTED', 'DECLINED', 'EXPIRED', 'WITHDRAWN']);
exports.hrOfferExtendSchema = zod_1.z.object({
    candidateId: zod_1.z.string().uuid(),
    proposedJoiningDate: zod_1.z.coerce.date(),
    compensationSummary: zod_1.z.string().trim().min(3).max(2000),
    terms: zod_1.z.string().trim().max(4000).optional(),
    offerDate: zod_1.z.coerce.date(),
    expiryDate: zod_1.z.coerce.date().optional(),
});
exports.hrOfferDeclineSchema = zod_1.z.object({
    reason: zod_1.z.string().trim().max(2000).optional(),
});
exports.hrOfferQuerySchema = zod_1.z.object({
    candidateId: zod_1.z.string().uuid().optional(),
    status: exports.hrOfferStatusEnum.optional(),
    cursor: zod_1.z.string().min(1).max(512).optional(),
    limit: zod_1.z.coerce.number().int().positive().max(200).default(50),
});
//# sourceMappingURL=hr-offer.schema.js.map